var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 109,
    viewBox: "0 0 106 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2725_13921)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.930664,
    width: 106,
    height: 108,
    rx: 53,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2725_13921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2842 53.7476C15.2842 31.8012 32.9742 14 54.7833 14C76.5925 14 94.2825 31.8012 94.2825 53.7476C94.2825 38.0671 81.6512 25.3564 66.0688 25.3564C50.4864 25.3564 37.8551 38.0671 37.8551 53.7476V59.4258H49.1406L26.5697 82.1387L3.99873 59.4258H15.2842V53.7476Z",
    fill: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.9307 74.2051C46.207 90.3348 57.0742 105.619 73.2033 108.342C89.3325 111.066 104.616 100.198 107.339 84.0683C110.063 67.9385 99.196 52.6549 83.0668 49.9312C66.9377 47.2076 51.6544 58.0754 48.9307 74.2051Z",
    fill: "#A2A2A2",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8926 53.7307C62.5839 54.1659 51.3371 66.1182 51.7723 80.427C52.2075 94.7358 64.1599 105.982 78.4686 105.547C92.7774 105.112 104.024 93.1597 103.589 78.851C103.154 64.5422 91.2014 53.2955 76.8926 53.7307Z",
    fill: "#E3E3E3",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0694 72.7626L77.6829 79.6284L81.3828 57.338",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8701 80.7008C79.4625 80.0447 79.4117 79.0337 78.7568 78.4403C78.1007 77.8479 77.0886 77.8986 76.4962 78.5536C75.9039 79.2085 75.9546 80.2206 76.6095 80.8141C77.2656 81.4076 78.2766 81.3568 78.8701 80.7008Z",
    fill: "#A2A2A2",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2725_13921"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.930664,
    width: 106,
    height: 108,
    rx: 53,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2725_13921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.2837,
    height: 68.1387,
    fill: "white",
    transform: "matrix(-1 0 0 1 94.2832 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHistory);
export default __webpack_public_path__ + "static/media/no_history.2df592e661841fe2049f9782c875cb25.svg";
export { ForwardRef as ReactComponent };